import { Component } from "react";
import { FormulaRow, CalculationResult, Formatter, CostData } from "namirasoft-bill-watch";

export interface CalculationResultViewProps 
{
	data: CostData[];
	value: CostData;
	formula?: FormulaRow;
	result: CalculationResult;
}

export default class CalculationResultView extends Component<CalculationResultViewProps>
{
	override render()
	{
		if (this.props.formula)
		{
			let logs = Formatter.getLogs(this.props.data, this.props.value, this.props.formula, this.props.result).join("\n");
			return (
				<pre
					style={{
						width: "100%",
						backgroundColor: "black",
						color: this.props.result.value === true ? "red" : (this.props.result.value === false ? "green" : "white")
					}}
				>
					{logs}
				</pre>
			);
		}
		return <></>;
	}
}